var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOurOfficeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4997 19.1666C19.3946 19.1666 18.3348 18.7277 17.5534 17.9463C16.772 17.1649 16.333 16.105 16.333 15C16.333 13.8949 16.772 12.8351 17.5534 12.0537C18.3348 11.2723 19.3946 10.8333 20.4997 10.8333C21.6047 10.8333 22.6646 11.2723 23.446 12.0537C24.2274 12.8351 24.6663 13.8949 24.6663 15C24.6663 15.5472 24.5586 16.089 24.3492 16.5945C24.1398 17.1 23.8329 17.5593 23.446 17.9463C23.059 18.3332 22.5997 18.6401 22.0942 18.8495C21.5887 19.0589 21.0468 19.1666 20.4997 19.1666ZM20.4997 3.33331C17.4055 3.33331 14.438 4.56248 12.2501 6.7504C10.0622 8.93832 8.83301 11.9058 8.83301 15C8.83301 23.75 20.4997 36.6666 20.4997 36.6666C20.4997 36.6666 32.1663 23.75 32.1663 15C32.1663 11.9058 30.9372 8.93832 28.7493 6.7504C26.5613 4.56248 23.5939 3.33331 20.4997 3.33331Z",
    fill: "#1E1E1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurOfficeIcon);
export default __webpack_public_path__ + "static/media/our-office-icon.e1ae89a18bb8f1e3f8cfc015341051a8.svg";
export { ForwardRef as ReactComponent };